import {
  START_FETCHING,
  STOP_FETCHING,
} from 'state/actions/CMT/Fetching'

const initialState = {
    counter: 0,
    text: void 0,
}

export default (state = initialState, action) => {
    let newState = null
    switch (action.type) {
    case START_FETCHING:
        return {
            counter: state.counter + 1,
            text: action.text || state.text,
        }
    case STOP_FETCHING:
        newState = {
            ...state,
        }
        newState.counter = newState.counter > 0 ? --newState.counter : 0
        newState.text = action.text === state.text || newState.counter === 0 ? void 0 : state.text
        return newState
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/CMT/Fetching.js